import { ODHSpace, ODVSpace } from '@mdpp/od-react-belt'
import React, { useEffect } from 'react'
import styled from 'styled-components'
import { TableList } from '../../common/list/TableList'
import { EvixInput } from '../../common/EvixInput'
import { validator } from '../../validator'
import { OvalGray, FormBlock, BtnWrap } from '../../common/style/SignUpStyle'
import _ from 'lodash'
import { InputCheckboxSupportWrapper, SwitchWrap, ToggleLabel, MessageIcon } from '../../common/style/CommonStyle'
import Toggle from 'react-toggle'
import { EvixSelector } from '../../common/EvixSelector'
import { COLORS } from '../../styles/colors'
import { WebUtils } from '../../utils/webUtils'
import IconWarningBlue from '../../assets/common/warning-blue.svg'
import { EvixInlineInputText } from '../../common/EvixInlineInputText'
import { GQLPharmacist } from '@mdpp/common/lib/@types/server.schema'
import { GQLHospital } from '@mdpp/common/lib/@types/server.schema'
import { usePharmacyAPIs } from '../context/usePharmacyAPIs'
import { EvixCard } from '../../common/card/EvixCard'
import { Page, PageContainer, PageHeader, PageTitle, PageContent } from '../../common/page/Page'
import { WarningMessageWrap } from '../../common/style/SignUpStyle'
import { useCommonAPIs } from '../../common/hooks/useCommonAPIs'
import { checkMessageWithPrefix } from '../../utils/registerServerErrorMessages'
import { ErrorCode } from '@mdpp/common'
import { EvixButton, EvixButtonTheme } from '../../common/EvixButton'
import IconDelete from '../../assets/common/icon_delete.png'
import { AddressSearchModal } from '../signup/AddressSearchModal'

interface IPharmacistMyPageProps {
  fromManager: boolean
  fromAdmin: boolean
  profile?: GQLPharmacist | null
}

interface IPharmacy {
  hospitalId?: number
  name?: string
  address?: string
  label?: string
  birthDate?: string
  cellPhone?: string
  email?: string
  licenseNumber?: string
  notiMarketing?: boolean
  pharmacistId?: number
  pharmacy?: any
  pharmacyId?: number | null
  unrecoverable?: boolean
  __typename?: null
  webFcmToken?: string | null
}

export const PharmacistMyPage: React.FC<IPharmacistMyPageProps> = props => {
  const { getPharmacistMyProfile, updatePharmacist, updatePharmacy } = usePharmacyAPIs()
  const { listHospitalForPharmacyChoose } = useCommonAPIs()
  const [origin, setOrigin] = React.useState<IPharmacy | null>()
  const [mdData, setMdData] = React.useState<IPharmacy | null>()
  const [availableDelivery, setAvailableDelivery] = React.useState(false)
  const [availableQuick, setAvailableQuick] = React.useState(false)
  const [fileName, setFileName] = React.useState('')
  const [data, setData] = React.useState<any[]>([])
  const [hospital, setHospital] = React.useState('')
  const [file, setFile] = React.useState({})
  const [bankBook, setBankBook] = React.useState('')
  const [bankBookFile, setBankBookFile] = React.useState('')
  const [nextBtn, setNextBtn] = React.useState(true)
  const [errBusinessMsg, setBusinessCodeMsg] = React.useState('')
  const [notiMarketing, setNotiMarketing] = React.useState(true)
  const [phone, setPhone] = React.useState('')
  const [showAddressSearchModal, setShowAddressSearchModal] = React.useState(false) // 주소 검색 Modal
  const [hospitalOptions, setHospitalOptions] = React.useState([
    { value: '연계 병원을 선택해주세요.', label: '연계 병원을 선택해주세요.' },
  ])
  const mapping = {
    hospitalId: 'value',
    name: 'label',
  }
  const uniqData = _.uniqBy(data, 'value')

  useEffect(() => {
    getApiPharmacistMyProfile()
    getOptions()
  }, [])

  useEffect(() => {
    setMdData(_.cloneDeep(origin))
  }, [origin])

  useEffect(() => {
    const isEqualhospitals = _.isEqual(origin?.pharmacy.hospitals, data)

    if (isEqualhospitals === true) {
      return setNextBtn(true)
    }
    setNextBtn(false)
  }, [data])

  useEffect(() => {
    setBusinessCodeMsg('')
  }, [mdData?.pharmacy?.businessLicenseNumber])

  useEffect(() => {
    const isEqualData = _.isEqual(origin, mdData)

    if (isEqualData === true) {
      return setNextBtn(true)
    }
    if (!phone || Object.keys(validator.account(phone)).length > 0) {
      return setNextBtn(true)
    }
    if (
      !mdData?.pharmacy.name ||
      !mdData?.pharmacy.address ||
      !mdData?.pharmacy.addressDetail ||
      !mdData?.pharmacy.zipCode ||
      !mdData?.pharmacy.accountHolder ||
      !mdData?.pharmacy.bankName
    ) {
      return setNextBtn(true)
    }
    if (!mdData.pharmacy?.telephone || Object.keys(validator.account(mdData.pharmacy?.telephone)).length > 0) {
      return setNextBtn(true)
    }
    if (!mdData.pharmacy?.fax || Object.keys(validator.account(mdData.pharmacy?.fax)).length > 0) {
      return setNextBtn(true)
    }
    if (
      !mdData.pharmacy?.businessLicenseNumber ||
      Object.keys(validator.account(mdData.pharmacy?.businessLicenseNumber)).length > 0
    ) {
      return setNextBtn(true)
    }
    if (!mdData.pharmacy?.accountNumber || Object.keys(validator.account(mdData.pharmacy?.accountNumber)).length > 0) {
      return setNextBtn(true)
    }
    if (!mdData.pharmacy.bankbookFile || !mdData.pharmacy.businessLicenseFile) {
      return setNextBtn(true)
    }
    setNextBtn(false)
  }, [mdData, phone])

  const reNameKey = (mapping: object, objName: Array<GQLHospital> | undefined) => {
    const reNameArr: Array<String | object> = []
    objName?.map((obj: any) => {
      if (obj.hasOwnProperty('name')) {
        obj.label = `${obj.name}/${obj.address}`
        delete obj.name
        delete obj.address
      }
      if (obj.hasOwnProperty('hospitalId')) {
        obj.value = obj.hospitalId
        delete obj.hospitalId
      }
      reNameArr.push(obj)
    })
    return setData(reNameArr)
  }

  const getApiPharmacistMyProfile = async () => {
    try {
      const r = await getPharmacistMyProfile()
      const objName = r.pharmacy?.hospitals
      reNameKey(mapping, objName)
      setOrigin(r)
      setNotiMarketing(r.notiMarketing)
      setPhone(r.cellPhone)
      setAvailableDelivery(r!.pharmacy!.availableDelivery!)
      setAvailableQuick(r!.pharmacy!.availableQuick!)
    } catch (e) {
      console.log(e)
    }
  }

  const pharmacistEditSave = async () => {
    const origins: any = origin!
    const mdDatas: any = mdData!

    const postDataPharmacist: any = { pharmacistId: origin?.pharmacistId }
    Object.keys(origins).map((v: string) => {
      if (mdDatas[v]) {
        if (mdDatas.notiMarketing !== origins.notiMarketing) {
          postDataPharmacist['notiMarketing'] = notiMarketing
        }
        delete postDataPharmacist.pharmacy
        if (origins[v] !== mdDatas[v]) {
          postDataPharmacist[v] = mdDatas[v]
        }
        return postDataPharmacist
      }
    })

    try {
      const result = await updatePharmacist(postDataPharmacist)
      getApiPharmacistMyProfile()
      return WebUtils.showSuccess('기본 정보가 변경되었습니다.')
    } catch (e) {
      console.log(e)
      if (checkMessageWithPrefix(e, ErrorCode.NO_UPDATE_FOUND)) {
        console.log('기본 정보 변경된 내용이 없습니다.')
      }
    }
  }

  const compareArray = (mdDatas: object, origins: object, datas: object) => {
    if (JSON.stringify(mdDatas) == JSON.stringify(datas)) {
      return true
    }
    if (JSON.stringify(origins) == JSON.stringify(datas)) {
      return true
    }
    return false
  }

  const pharmacyEditSave = async () => {
    const origins: any = origin?.pharmacy
    const mdDatas: any = mdData?.pharmacy
    const dataValue: Array<number> = _.uniqBy(data, 'value').map(v => {
      const no: number = v?.value
      return no
    })

    const isKeyExists = (obj: any, key: any) => {
      if (obj[key] == undefined) {
        return false
      } else {
        return true
      }
    }

    const postData: any = { id: origin?.pharmacy.pharmacyId }
    Object.keys(origins).map((v: string) => {
      if (mdDatas[v]) {
        if (isKeyExists(postData, 'hospitals') === true) {
          delete postData.hospitals
          if (compareArray(mdData?.pharmacy.hospitals, origin?.pharmacy.hospitals, uniqData) === true) {
            delete postData.hospitals
          } else {
            postData['hospitalId'] = dataValue!
          }
        }
        if (mdDatas.availableDelivery !== origins.availableDelivery) {
          postData['availableDelivery'] = availableDelivery
        }
        if (mdDatas.availableQuick !== origins.availableQuick) {
          postData['availableQuick'] = availableQuick
        }
        if (
          origin?.pharmacy.businessLicenseFile?.blfId !== undefined &&
          mdData?.pharmacy.businessLicenseFile?.blfId === origin?.pharmacy.businessLicenseFile?.blfId
        ) {
          delete postData.businessLicenseFile
        }
        if (
          origin?.pharmacy.bankbookFile?.bbfId !== undefined &&
          mdData?.pharmacy.bankbookFile?.bbfId === origin?.pharmacy.bankbookFile?.bbfId
        ) {
          delete postData.bankbookFile
        }
        if (origins[v] !== mdDatas[v]) {
          postData[v] = mdDatas[v]
        }
        return postData
      }
    })

    if (Object.keys(mdData?.pharmacy).length === 0) {
      return
    }

    try {
      const r = await updatePharmacy(postData)
      getApiPharmacistMyProfile()
      return WebUtils.showSuccess('약국 정보가 변경 되었습니다.')
    } catch (e) {
      console.log(e)
      if (checkMessageWithPrefix(e, ErrorCode.NO_UPDATE_FOUND)) {
        console.log('약국 정보 변경된 내용이 없습니다.')
      }
      if (checkMessageWithPrefix(e, ErrorCode.BUSINESS_LICENSE_ALREADY_EXIST)) {
        setBusinessCodeMsg('이미 등록된 기관입니다. 가입 정보 확인은 관리자에게 문의해주세요.')
        setNextBtn(true)
      }
    }
  }

  const handleEditSave = async () => {
    await pharmacistEditSave()
    await pharmacyEditSave()
  }

  const handleAddressSelect = (address: string, zonecode: string) => {
    setMdData({
      ...mdData,
      pharmacy: {
        ...mdData?.pharmacy,
        address: address,
        zipCode: zonecode,
      },
    })
  }

  const fileChangedHandler = (e: any) => {
    const files = e.target.files
    const fileSize = files[0]?.size
    const fileChangeName = files[0]?.name

    if (files[0]?.name === null) {
      return console.log('파일없음')
    }
    if (fileSize > 50000000) {
      return WebUtils.showError('첨부파일 사이즈는 50MB 이내로 등록 가능합니다.')
    }

    setFileName(fileChangeName ? fileChangeName : mdData?.pharmacy?.businessLicenseFile?.name)
    setFile(files[0])

    fileSaveHandler(files[0])
  }

  const fileBankBookChangedHandler = (e: any) => {
    const files = e.target.files
    const fileSize = files[0]?.size
    const fileChangeName = files[0]?.name

    if (files[0]?.name === null) {
      return console.log('파일없음')
    }
    if (fileSize > 50000000) {
      return WebUtils.showError('첨부파일 사이즈는 50MB 이내로 등록 가능합니다.')
    }

    setBankBook(fileChangeName ? fileChangeName : mdData?.pharmacy?.bankbookFile?.name)
    setBankBookFile(files[0])

    fileBankBookSaveHandler(files[0])
  }

  const fileSaveHandler = (files: object) => {
    setMdData({
      ...mdData,
      pharmacy: {
        ...mdData?.pharmacy,
        businessLicenseFile: files ? files : mdData?.pharmacy.businessLicenseFile,
      },
    })
  }

  const fileBankBookSaveHandler = (files: object) => {
    setMdData({
      ...mdData,
      pharmacy: {
        ...mdData?.pharmacy,
        bankbookFile: files ? files : mdData?.pharmacy.bankbookFile,
      },
    })
  }
  const hospitalList = _.uniqBy(data, 'value').map((v, idx: number) => (
    <SelectedItem key={idx}>
      <span>{v?.label}</span>
      <button type="button" onClick={() => handelDeleteHospital(v?.label)}>
        <img src={IconDelete} style={{ width: 12, height: 12 }} />
      </button>
    </SelectedItem>
  ))

  const handelDeleteHospital = (label: string) => {
    setData(data?.filter(data => data?.label !== label))
  }

  const onChangeHospital = (value: any) => {
    setHospital(value)
    UpDateDateList(value)
  }

  const getOptions = async () => {
    try {
      const res = await listHospitalForPharmacyChoose({})
      const dataList = res.list
      const options = dataList.map((d: any) => ({
        value: d.hospitalId,
        label: `${d.name}/${d.address}`,
      }))
      setHospitalOptions([{ value: '연계 병원을 선택해주세요.', label: '연계 병원을 선택해주세요.' }, ...options])
    } catch (e) {
      console.log(e)
    }
  }

  const UpDateDateList = (value: any) => {
    let names = _.map(data, 'label')
    const result = names.indexOf(value.label)

    if (data.length > 4) {
      return WebUtils.showError('5개 이상 등록할 수 없습니다.')
    }
    if (value.value === '연계 병원을 선택해주세요.') {
      return
    }
    if (result > -1) {
      return WebUtils.showError('이미 등록한 병원입니다.')
    }
    setData(data.concat(value))
  }

  const HandleMarketingCheck = () => {
    setNotiMarketing(!notiMarketing)
    setMdData({
      ...mdData,
      email: mdData?.email,
      name: mdData?.name,
      birthDate: mdData?.birthDate,
      licenseNumber: mdData?.licenseNumber,
      cellPhone: mdData?.cellPhone,
      notiMarketing: !notiMarketing,
    })
  }

  const HandlePhone = (value: string) => {
    setPhone(value)
    setMdData({
      ...mdData,
      email: mdData?.email,
      name: mdData?.name,
      birthDate: mdData?.birthDate,
      licenseNumber: mdData?.licenseNumber,
      cellPhone: value,
      notiMarketing: mdData?.notiMarketing,
    })
  }

  const HandleToggle = () => {
    setAvailableDelivery(!availableDelivery)
    setAvailableQuick(!availableQuick)
    setMdData({
      ...mdData,
      pharmacy: {
        ...mdData?.pharmacy,
        availableDelivery: !availableDelivery,
        availableQuick: !availableQuick,
      },
    })
  }

  return (
    <PageContainer>
      <Page>
        <PageHeader>
          <PageTitle>마이페이지</PageTitle>
        </PageHeader>
        <PageContent>
          <EvixCard>
            <Wrapper>
              <SubTitle>기본 정보</SubTitle>

              <PharmacyAddInfo>
                <PharmacyAddInfoBlock className="block email">
                  <div className="label">이메일 아이디</div>
                  {origin && origin.email}
                </PharmacyAddInfoBlock>

                <PharmacyAddInfoBlock className="block">
                  <div className="label">이름</div>
                  {origin && origin.name}
                </PharmacyAddInfoBlock>

                <PharmacyAddInfoBlock className="block">
                  <div className="label">생년월일</div>
                  {origin && origin.birthDate}
                </PharmacyAddInfoBlock>

                <PharmacyAddInfoBlock className="block">
                  <div className="label">약사면허번호</div>
                  {origin && origin.licenseNumber}
                </PharmacyAddInfoBlock>
              </PharmacyAddInfo>

              <TableList name="telephone" label="휴대폰 번호" mandatoryInput>
                <ColumnWrap>
                  <EvixInput
                    style={{ width: 300 }}
                    value={phone}
                    onChange={HandlePhone}
                    validators={validator.account}
                    disabled={false}
                  />
                  <WarningMessageWrap>
                    <ul>
                      <li>
                        <OvalGray></OvalGray> 마케팅 정보 수신 동의여부
                        <InputCheckboxSupportWrapper style={{ marginLeft: 10 }}>
                          <input type="checkbox" id="radio1" onChange={HandleMarketingCheck} checked={notiMarketing} />
                          <label htmlFor="radio1">동의</label>
                        </InputCheckboxSupportWrapper>
                      </li>
                    </ul>
                  </WarningMessageWrap>
                </ColumnWrap>

                <WarningMessageWrap
                  className={Object.keys(validator.account(phone)).length !== 0 ? 'hide' : ''}
                ></WarningMessageWrap>
              </TableList>

              <ODVSpace h={34} />

              <SubTitle>약국 정보</SubTitle>

              <TableList name="name" label="약국 이름" mandatoryInput>
                <EvixInlineInputText
                  style={{ width: 300 }}
                  value={mdData && mdData.pharmacy?.name}
                  onChange={value => {
                    setMdData({
                      ...mdData,
                      pharmacy: {
                        ...mdData?.pharmacy,
                        name: value,
                      },
                    })
                  }}
                  disabled={false}
                />
                <WarningMessageWrap></WarningMessageWrap>
              </TableList>

              <TableList name="pharmacyAddress" label="주소" mandatoryInput>
                <AddressWrap onClick={() => setShowAddressSearchModal(true)}>
                  <EvixInlineInputText
                    style={{ width: '100%' }}
                    value={mdData && mdData.pharmacy?.address}
                    onChange={value => {
                      setMdData({
                        ...mdData,
                        pharmacy: {
                          ...mdData?.pharmacy,
                          address: value,
                        },
                      })
                    }}
                    disabled={true}
                  />

                  <EvixInlineInputText
                    style={{ width: 150 }}
                    value={mdData && mdData.pharmacy?.zipCode}
                    onChange={value => {
                      setMdData({
                        ...mdData,
                        pharmacy: {
                          ...mdData?.pharmacy,
                          zipCode: value,
                        },
                      })
                    }}
                    disabled={true}
                  />
                  <EvixButton
                    theme={EvixButtonTheme.H48WhiteInline}
                    onClick={() => setShowAddressSearchModal(true)}
                    disabled={false}
                  >
                    검색
                  </EvixButton>
                </AddressWrap>
                <ODVSpace h={10} />
                <EvixInlineInputText
                  style={{ width: '100%' }}
                  value={mdData && mdData.pharmacy?.addressDetail}
                  onChange={value => {
                    setMdData({
                      ...mdData,
                      pharmacy: {
                        ...mdData?.pharmacy,
                        addressDetail: value,
                      },
                    })
                  }}
                  disabled={false}
                />
                <WarningMessageWrap></WarningMessageWrap>
              </TableList>

              <ColumnWrap>
                <TableList name="telephone" label="연락처" mandatoryInput>
                  <EvixInput
                    style={{ width: '100%' }}
                    validators={validator.account}
                    value={mdData && mdData.pharmacy?.telephone}
                    onChange={value => {
                      setMdData({
                        ...mdData,
                        pharmacy: {
                          ...mdData?.pharmacy,
                          telephone: value,
                        },
                      })
                    }}
                    disabled={false}
                  />
                  <WarningMessageWrap
                    className={
                      Object.keys(validator.account(mdData && mdData.pharmacy?.telephone)).length !== 0 ? 'hide' : ''
                    }
                  ></WarningMessageWrap>
                </TableList>
                <TableList name="fax" label="FAX" mandatoryInput>
                  <FormBlock>
                    <EvixInput
                      style={{ width: '100%' }}
                      validators={validator.account}
                      value={mdData && mdData.pharmacy?.fax}
                      onChange={value => {
                        setMdData({
                          ...mdData,
                          pharmacy: {
                            ...mdData?.pharmacy,
                            fax: value,
                          },
                        })
                      }}
                      disabled={false}
                    />
                    <WarningMessageWrap
                      className={
                        Object.keys(validator.account(mdData && mdData.pharmacy?.fax)).length !== 0 ? 'hide' : ''
                      }
                    ></WarningMessageWrap>
                  </FormBlock>
                </TableList>
              </ColumnWrap>

              <ColumnWrap>
                <TableList name="businessLicenseNumber" label="사업자등록번호" labelMDSize={12} mandatoryInput>
                  <EvixInput
                    style={{ width: '100%' }}
                    value={mdData && mdData.pharmacy?.businessLicenseNumber}
                    onChange={value => {
                      setMdData({
                        ...mdData,
                        pharmacy: {
                          ...mdData?.pharmacy,
                          businessLicenseNumber: value,
                        },
                      })
                    }}
                    validators={validator.account}
                    disabled={false}
                  />
                  <WarningMessageWrap
                    className={
                      Object.keys(validator.account(mdData && mdData.pharmacy?.businessLicenseNumber)).length !== 0
                        ? 'hide'
                        : ''
                    }
                  >
                    <span className="error" style={{ fontSize: 13, fontWeight: 500, color: '#ff5353' }}>
                      {errBusinessMsg}
                    </span>
                  </WarningMessageWrap>
                </TableList>
                <TableList name="fileName" label="사업자등록증" labelMDSize={12} mandatoryInput>
                  <FileWrap>
                    <FileInput>
                      {mdData && mdData.pharmacy?.businessLicenseFile?.fileName === '' ? (
                        <NoFileName style={{ width: 'auto', flex: 1, cursor: 'default' }}>
                          PDF, JPG, PNG 파일만 첨부 가능
                        </NoFileName>
                      ) : (
                        <>
                          {mdData && mdData.pharmacy?.businessLicenseFile?.fileName
                            ? mdData.pharmacy?.businessLicenseFile?.fileName
                            : fileName
                            ? fileName
                            : origin?.pharmacy?.businessLicenseFile?.fileName}
                        </>
                      )}
                    </FileInput>
                    <FileLabel htmlFor="input-file">
                      {' '}
                      사업자등록증 첨부
                      <input
                        name="businessLicenseFile"
                        type="file"
                        id="input-file"
                        style={{ display: 'none' }}
                        accept=".pdf, image/png, image/jpeg, image/jpg"
                        onChange={e => fileChangedHandler(e)}
                      />
                    </FileLabel>
                  </FileWrap>
                  <WarningMessageWrap>
                    <ul>
                      <li className="align-center">
                        <MessageIcon src={IconWarningBlue} alt="warning icon" />
                        비대면 진료 정산을 위해 필요합니다.
                      </li>
                    </ul>
                  </WarningMessageWrap>
                </TableList>
              </ColumnWrap>
              <ColumnWrap>
                <TableList name="bankBook" label="통장사본" labelMDSize={12} mandatoryInput>
                  <FileWrap>
                    <FileInput>
                      {mdData && mdData.pharmacy?.bankbookFile === null ? (
                        <NoFileName style={{ width: 'auto', flex: 1, cursor: 'default' }}>
                          PDF, JPG, PNG 파일만 첨부 가능
                        </NoFileName>
                      ) : (
                        <>
                          {mdData && mdData.pharmacy?.bankbookFile?.fileName
                            ? mdData.pharmacy?.bankbookFile?.fileName
                            : bankBook
                            ? bankBook
                            : origin?.pharmacy?.bankbookFile?.fileName}
                        </>
                      )}
                    </FileInput>
                    <FileLabel htmlFor="input-bank-file">
                      {' '}
                      통장사본 첨부
                      <input
                        name="bankBookFile"
                        type="file"
                        id="input-bank-file"
                        style={{ display: 'none' }}
                        accept=".pdf, image/png, image/jpeg, image/jpg"
                        onChange={e => fileBankBookChangedHandler(e)}
                      />
                    </FileLabel>
                  </FileWrap>
                  <WarningMessageWrap>
                    <ul>
                      <li className="align-center">
                        <MessageIcon src={IconWarningBlue} alt="warning icon" />
                        조제비 정산을 위해 필요합니다.
                      </li>
                    </ul>
                  </WarningMessageWrap>
                </TableList>
                <div></div>
              </ColumnWrap>
              <ODVSpace h={20} />
              <ColumnWrap>
                <TableList
                  name="availableDelivery"
                  label="의약품 택배 / 퀵 배송 배송가능 여부"
                  labelMDSize={12}
                  mandatoryInput
                >
                  <AddressWrap>
                    <SwitchWrap style={{ display: 'inline-flex' }}>
                      <Toggle checked={availableDelivery} icons={false} onChange={HandleToggle} />
                      <ToggleLabel>
                        <span>불가능</span>
                        <span>가능</span>
                      </ToggleLabel>
                    </SwitchWrap>
                    <ODHSpace w={50} />
                    {availableDelivery === true && (
                      <InputCheckboxSupportWrapper>
                        <input
                          type="checkbox"
                          id="cb1"
                          checked={availableQuick}
                          disabled={true}
                          // onChange={value => {
                          //   setMdData({
                          //     ...mdData,
                          //     pharmacy: {
                          //       ...mdData?.pharmacy,
                          //       availableQuick: true,
                          //     },
                          //   })
                          // }}
                        />
                        <label htmlFor="cb1">퀵 배송</label>
                      </InputCheckboxSupportWrapper>

                      // <TableList name="availableQuick" label="" labelMDSize={12}>
                      //   <input
                      //     type="radio"
                      //     id="radio1"
                      //     onChange={value => {
                      //       setOrigin({
                      //         ...mdData,
                      //         pharmacy: {
                      //           ...mdData.pharmacy,
                      //           availableQuick: true,
                      //         },
                      //       })
                      //     }}
                      //     checked={mdData && mdData.pharmacy.availableQuick}
                      //   />
                      //   <label htmlFor="radio1" style={{ marginBottom: 0 }}>
                      //     퀵배송
                      //   </label>
                      //   <ODHSpace w={10} />
                      //   <input
                      //     type="radio"
                      //     id="radio2"
                      //     onChange={value => {
                      //       setOrigin({
                      //         ...mdData,
                      //         pharmacy: {
                      //           ...mdData?.pharmacy,
                      //           availableQuick: false,
                      //         },
                      //       })
                      //     }}
                      //     checked={mdData! && !mdData?.pharmacy.availableQuick}
                      //   />
                      //   <label htmlFor="radio2" style={{ marginBottom: 0 }}>
                      //     택배 배송
                      //   </label>
                      // </TableList>
                    )}
                  </AddressWrap>
                  <WarningMessageWrap>
                    <ul>
                      <li>
                        <OvalGray></OvalGray> 배송이 불가능한 경우 입력하신 FAX로 메디팡팡 회원의 처방전을 받으실 수
                        있습니다.
                      </li>
                    </ul>
                  </WarningMessageWrap>
                  <ODVSpace h={10} />
                </TableList>

                <TableList name="hospital" label="연계 병원" labelMDSize={6}>
                  <EvixSelector
                    style={{ width: '100%' }}
                    value={'연계 병원을 선택해주세요.'}
                    placeholder={'연계 병원을 선택해주세요.'}
                    options={hospitalOptions}
                    onChange={value => onChangeHospital(value)}
                  />
                  <SelectedItemWrap>{hospitalList}</SelectedItemWrap>
                </TableList>
              </ColumnWrap>

              <ODVSpace h={34} />

              <SubTitle>계좌 정보</SubTitle>
              <ColumnWrap>
                <TableList name="bankName" label="은행명" mandatoryInput>
                  <EvixInput
                    style={{ width: '100%' }}
                    value={mdData && mdData.pharmacy?.bankName}
                    onChange={value => {
                      setMdData({
                        ...mdData,
                        pharmacy: {
                          ...mdData?.pharmacy,
                          bankName: value,
                        },
                      })
                    }}
                    disabled={false}
                  />
                </TableList>
                <TableList name="accountHolder" label="예금주" mandatoryInput>
                  <EvixInput
                    style={{ width: '100%' }}
                    value={mdData && mdData.pharmacy?.accountHolder}
                    onChange={value => {
                      setMdData({
                        ...mdData,
                        pharmacy: {
                          ...mdData?.pharmacy,
                          accountHolder: value,
                        },
                      })
                    }}
                    disabled={false}
                  />
                </TableList>
              </ColumnWrap>
              <ColumnWrap>
                <TableList name="accountNumber" label="계좌번호" mandatoryInput>
                  <EvixInput
                    style={{ width: '100%' }}
                    value={mdData && mdData.pharmacy?.accountNumber}
                    onChange={value => {
                      setMdData({
                        ...mdData,
                        pharmacy: {
                          ...mdData?.pharmacy,
                          accountNumber: value,
                        },
                      })
                    }}
                    validators={validator.account}
                    disabled={false}
                  />
                  <WarningMessageWrap
                    className={
                      Object.keys(validator.account(mdData && mdData.pharmacy?.accountNumber)).length !== 0
                        ? 'hide'
                        : ''
                    }
                  ></WarningMessageWrap>
                </TableList>
                <div></div>
              </ColumnWrap>
              <BtnWrap>
                <EvixButton theme={EvixButtonTheme.H48Black} onClick={() => handleEditSave()} disabled={nextBtn}>
                  저장
                </EvixButton>
              </BtnWrap>
            </Wrapper>
          </EvixCard>
        </PageContent>
      </Page>

      {showAddressSearchModal && (
        <AddressSearchModal
          style={{ width: 880, height: 764, maxWidth: 880 }}
          onSelected={handleAddressSelect}
          onCancelPress={() => setShowAddressSearchModal(false)}
        />
      )}
    </PageContainer>
  )
}

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`

const InfoMessageWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: 10px;
`

const InfoMessage = styled.div`
  font-size: 13px;
  font-weight: 500;
  line-height: 1.17;
  color: #ababab;
`

const InfoIcon = styled.img`
  width: 14px;
  height: 14px;
  margin-right: 4px;
`

const SubTitle = styled.div`
  font-size: 15px;
  font-weight: 700;
  padding-bottom: 10px;
`

const PharmacyAddInfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  &.email {
    width: 218px;

    input {
      width: 100%;
      border-color: #f4f6f8 !important;
      background-color: #f4f6f8 !important;
      outline: none !important;
      padding-left: 0 !important;
      padding-right: 0 !important;

      &:focus {
        border-color: #f4f6f8 !important;
        outline: none !important;
      }
    }
  }

  .label {
    font-size: 12px;
    font-weight: 500;
    color: #909ca7;
  }

  .label ~ div,
  .label ~ div > div {
    border-radius: 1px !important;
  }

  .value {
    font-size: 15px;
    font-weight: 500;
    color: #424242;
    white-space: nowrap;
  }

  input {
    width: 120px;
    height: 35px;
    font-size: 15px;
    font-weight: 500;
    color: #424242;
    display: inline-block !important;
    border-radius: 1px !important;
    background-color: #fff !important;
  }
`

const ColumnWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 32px;

  > div {
    width: 50%;
  }
`

const AddressWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
`

const RowWrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`

const PharmacyAddInfo = styled.p`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 0 !important;
  /* width: 680px; */
  padding: 18px 50px 18px 30px;
  background-color: #f4f6f8;
  gap: 50px;
`

const FileLabel = styled.label`
  font-size: 13px;
  font-weight: 500;
  font-style: normal;
  color: ${COLORS.GRAY42};
  margin-bottom: 0;
  padding: 12px;
  height: 44px;
  width: 130px;
  line-height: 18px;
  border-radius: 4px;
  border: 1px solid ${COLORS.GRAYAB2};
  background-color: ${COLORS.WHITE};
  text-align: center;
  cursor: pointer;
`

const FileWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: 10px;

  .od-input-wrapper {
    border: none;

    .od-input {
      &::placeholder {
        color: ${COLORS.GRAYAB};
        font-size: 13px;
      }
    }
  }

  [class*='SignUpStyle__WarningMessageWrap'] {
    display: none;
  }
`

const FileInput = styled.label`
  font-size: 13px;
  font-weight: 500;
  font-style: normal;
  color: ${COLORS.GRAY42};
  margin-bottom: 0;
  padding: 12px;
  height: 44px;
  width: calc(100% - 130px);
  line-height: 18px;
  border-radius: 4px;
  border: 1px solid #dfe0e2;
  background-color: #eeeff1;
  text-align: left;
  cursor: pointer;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  span {
    color: #acb4bc;
  }
`

const NoFileName = styled.div`
  flex: 1;
  font-size: 13px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: 0;
  color: ${COLORS.GRAYAB};
`

const Label = styled.label`
  font-size: 15px;
  font-weight: 500;
  font-style: normal;
  color: ${COLORS.GRAY42};
  margin-bottom: 0;
  padding: 12px 0;
  height: 44px;
  line-height: 18px;
  border-radius: 4px;
  border: 0;
  background-color: transparent;
  text-align: left;
  cursor: pointer;
`

const SelectedItemWrap = styled.div`
  margin-top: 10px;
`

const SelectedItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0;
  padding: 0 14px;
  height: 44px;
  border-radius: 4px;
  border: 1px solid #dfe0e2;
  background-color: #fff;
  text-align: left;
  cursor: pointer;
  margin-bottom: 5px;

  > span {
    font-size: 13px;
    font-weight: 500;
    font-style: normal;
    color: #7c818b;
    line-height: 18px;
  }

  > button {
  }
`
